import { Box } from "@mui/material";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  InfluenceField,
  VisualIntegration,
} from "../../../../types";
import { selectCatalogById } from "../../../../redux/selector";
import { adminCatalogActions } from "../../../../redux/slice";
import { CatalogFieldControl } from "./FormControls";
import { useStyles } from "./styles";

interface CatalogDetailsProps {
  id: number;
}

const INFLUENCE_FIELD_OPTIONS: InfluenceField[] = [
  "ENGINEERING/CALC",
  "SPACING_LOGIC",
  "HEIGHT/WEIGHT",
];

const VISUAL_INTEGRATION_OPTIONS: VisualIntegration[] = [
  "UPDATING_DIAGRAM",
  "DIAGRAMMATIC_LAYOUT",
  "STATIC_LAYER",
];

const influenceFieldOptions: [string, string][] = INFLUENCE_FIELD_OPTIONS.map(
  (value) => [value, `CATALOGS.INFLUENCE_FIELD_VALUES.${value}`]
);

const visualIntegrationOptions: [string, string][] =
  VISUAL_INTEGRATION_OPTIONS.map((value) => [
    value,
    `CATALOGS.VISUAL_INTEGRATION_VALUES.${value}`,
  ]);

const CatalogDetails = ({ id }: CatalogDetailsProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentRow = useSelector(selectCatalogById(id));
  const styles = useStyles();

  const handleMainInfluenceFieldChange = useCallback(
    (value: string) => {
      dispatch(
        adminCatalogActions.setMainInfluenceField({
          id,
          influenceField: value as InfluenceField,
        })
      );
    },
    [dispatch, id]
  );

  const handleVisualIntegrationChange = useCallback(
    (value: string) => {
      dispatch(
        adminCatalogActions.setVisualIntegration({
          id,
          visualIntegration: value as VisualIntegration,
        })
      );
    },
    [dispatch, id]
  );

  return (
    <Box className={styles.card}>
      <Box className={styles.row}>
        <CatalogFieldControl
          labelKey="CATALOGS.TABLE.CATALOG_NAME"
          value={currentRow?.catalogName ? t(currentRow.catalogName) : ""}
        />
        <CatalogFieldControl
          labelKey="CATALOGS.TABLE.DESCRIPTION"
          value={currentRow?.description ? t(currentRow.description) : ""}
        />
        <CatalogFieldControl
          labelKey="CATALOGS.TABLE.MAIN_INFLUENCE_FIELD"
          value={currentRow?.mainInfluenceField ?? ""}
          options={influenceFieldOptions}
          onChange={handleMainInfluenceFieldChange}
        />
        <CatalogFieldControl
          labelKey="CATALOGS.TABLE.VISUAL_INTEGRATION"
          value={currentRow?.visualIntegration ?? ""}
          options={visualIntegrationOptions}
          onChange={handleVisualIntegrationChange}
        />
      </Box>
    </Box>
  );
};

export default CatalogDetails;
